































import Vue from "vue";
import {Component} from "vue-property-decorator";
import {CurrentGame} from "../../../types";
// @ts-ignore
import store from "../../store";
import MessageHelper from "../../helpers/MessageHelper";
import EventApi from "../../api/EventsApi";
@Component({
    components: {},
    props: {}
})

export default class PageLoader extends Vue {
    private progress: number = 0;

    mounted(): void
    {
        const timer = setInterval(() => {
            this.progress++;
            if (this.progress === 95) {
                const pixiScene = window.PixiScene;

                if (pixiScene) {
                    //EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER, {stage: this});
                    pixiScene.resize && pixiScene.resize();
                    //Убрать после рефактора сцены
                    pixiScene.resizeHandler && pixiScene.resizeHandler(true);
                }
            }
            if (this.progress === 100) {
                clearInterval(timer);
                this.close();
            }
        }, 1500 / 100);
    }

    /**
     * Текущая игра
     * @private
     */
    private get currentActivity(): null|CurrentGame
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Закрыть лоадер
     * @private
     */
    private close(): void
    {
        this.$emit('close');
    }
}
